
  import React from 'react'
  import { MDXTag } from '@mdx-js/tag'
  

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = null
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             
             components={components}><MDXTag name="p" components={components}>{`Es hat lange gedauert. In den letzten zwei Jahrzehnten haben die Kantone auf Geheiss des Bundes spezielle Karten erstellt. Die sogenannten Gefahrenkarten zeigen, welche Gebiete durch Naturgefahren bedroht sind. Konkret durch Hochwasser, Lawinen, Rutschungen und Sturzprozesse.`}</MDXTag>
<MDXTag name="p" components={components}>{`Für Lawinen und Hochwasser ist inzwischen praktisch die gesamte Fläche der Schweiz erfasst. Die meisten Kantone haben ihre entsprechenden Karten auch online zugänglich gemacht. `}<br/><b>{`Was fehlt, ist ein schweizweit einheitliches Tool. Ein solches haben nun das Datenteam und das Interaktiv-Team von Tamedia erstellt.`}</b>{` Sie können damit Adressen überprüfen oder
eine Region nach Gefahrengebieten absuchen.`}</MDXTag>
<MDXTag name="p" components={components}>{`Naturgefahren betreffen in der Schweiz nicht nur die Bergregionen. Das zeigt sich insbesondere bei den Hochwassern. Auch im dicht bebauten Mittelland liegen grosse Flächen in Gefahrengebieten. Die Auswertung der Gefahrenkarten hat ergeben, dass hier schätzungsweise eine Million Menschen wohnen. Und mit dem Klimawandel wird die Zahl der Extremereignisse in der Schweiz zunehmen.`}</MDXTag>
           </MDXTag>
  }
}
MDXContent.isMDXComponent = true
  